import axios from 'axios';

export async function cartContainsAssets(assetIds) {
  if (!assetIds?.length) {
    return [];
  }
  try {
    const response = await axios.get('/purchase/carts/contains-assets', {
      params: {
        ids: assetIds.join(','),
        timeout: 300,
      },
      headers: {
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (e) {
    return [];
  }
}
export async function addAsset(assetId) {
  const response = await axios.post('/purchase/carts/add-asset.json', {
    asset_id: assetId,
  });
  if (response.status === 200) return assetId;
  return null;
}
export async function removeAsset(assetId) {
  const response = await axios.post('/purchase/carts/remove-asset.json', {
    asset_id: assetId,
  });
  if (response.status === 200) return assetId;
  return null;
}
